/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-10-23 11:03:50
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { post, get } from 'src/api/http';
import * as types from './type';
import {TaskMess, TaskResult, ReturnPageData} from 'src/api/types.d';

class RemoteControl {
    getMeterList (data:types.MeterListParams): Promise<types.MeterListData> {
        return post('/amr/remote-control/meters', data);
    }
    stateSynchronous (data:types.StateSynchronousParams): Promise<TaskMess> {
        return post('/amr/remote-control/state-synchronous', data);
    }
    getTaskGroupByRemark (data: types.TaskGroupModuleParmas): Promise<ReturnPageData<types.TaskGroupModuleData>> {
        return get('/amr/random-read/task-group-by-module', data);
    }
    gettaskList (data:types.TaskListParams): Promise<types.TaskListData> {
        return get('/amr/random-read/task-list', data);
    }
    getTaskListGroup (data: types.TaskListGroupParams): Promise<types.TaskListData> {
        return get('/amr/random-read/task-list-by-group', data);
    }
    resetTask (data:types.ResetTaskParams):Promise<TaskMess> {
        return post('/amr/random-read/reset-task', data);
    }
    confirmUser (data: types.ConfirmUserParms): Promise<TaskMess> {
        return post('/amr/remote-control/confirm-user', data);
    }
    getGuid ():Promise<TaskMess> {
        return get('/amr/remote-control/guid');
    }
    sendCmdByMeter (data:types.SendCmdByMeterParams):Promise<TaskMess> {
        return post('/amr/remote-control/send-cmd-by-meter', data);
    }
    getMeterByTask (taskId:string): Promise<TaskResult> {
        return get(`/amr/remote-control/meter-by-taskid?taskId=${taskId}`);
    }
    importConnectMeter (data:types.ImportConnectMeterParams): Promise<any> {
        return get('/amr/remote-control/import-connect-meter', data);
    }
    importConnectProgress (fileId: string): Promise<any> {
        return get('/amr/remote-control/import-progress', {fileId});
    }
}

export default new RemoteControl();
